/// <reference path="../../setup/_references.ts" />
module onvio.practice.widgets {
    'use strict';

    export class BmPracticeWidgetPriorInvoices implements IBmPracticeWidgetService {

        /** Flag if the widget is busy */
        public isBusy: boolean = false;

        /** Ensure the invoice widgets refresh together */
        public coalescingServiceArea: string = 'invoices';

        /** Templates for the widget */
        public bodyTemplate: string = 'practice-widgets/prior-invoices/prior-invoices.html';
        public headerTemplate: string = 'practice-widgets/practice-widget-date-search-header.html';
        public size: WidgetSize = 'small';

        static $inject = [
            '$q',
            'csClientPriorInvoiceV1',
            'bmPracticeWidgetInvoiceService',
            'bmpBigNumberUtils',
            'bmpDateUtils'
        ];
        constructor(
            private $q: ng.IQService,
            private dataService: cs.IClientPriorInvoiceV1Service,
            private invoiceService: BmPracticeWidgetInvoiceService,
            private bigNumberUtils: bmp.globalize.IBigNumberUtils,
            private dateUtils: bmp.globalize.IDateUtils) {
        }

        public loadData(args: IBmPracticeWidgetLoadDataArgs): ng.IPromise<any> {

            if (!args.context || !args.contextId || !args.dateRangeId) {
                return this.$q.when(undefined);
            }

            let filter = new bmp.Filter();

            if (!!args.startDate) {
                filter.and().where('entryDate').isGreaterThanOrEquals(args.startDate);
            }
            if (!!args.endDate) {
                filter.and().where('entryDate').isLessThanOrEquals(args.endDate);
            }

            var params: any = {
                filterSearchSort: {
                    orderBy: 'entryDate asc',
                    search: args.searchText,
                    searchBy: 'dueDate,entryDate,entryNumber,openAmount,realizationPercentage,reference,invoicedAmount',
                    filter: filter.toString(),
                },
                pagingDataRequest: {
                    startIndex: ((args.pageIndex - 1) * 25) + 1,
                    pageIndex: args.pageIndex,
                    itemsPerPage: 25
                }
            };
            let getListPromise = this.dataService.postSearch({ clientId: args.contextId, postData: params });
            return getListPromise.then((response: any) => { // TODO - ng161 - handle reject from getList
                let today = moment();
                response.items = _.map(response.items, (item: cs.IClientPriorInvoiceV1Dto) => {
                    // Paid when there is no open amount remaining
                    let isPaid = +item.openAmount === 0;
                    // Partially paid when not fully paid, there is still an open amount and the open amount is not the full invoice amount
                    let isPartiallyPaid = !isPaid && +item.openAmount > 0 && +item.openAmount !== +item.invoicedAmount;
                    return {
                        id: item.id,
                        client: args.context,
                        entryNumber: item.entryNumber,
                        reference: item.reference,
                        entryDate: this.formatDate(item.entryDate),
                        entryDateInvariant: item.entryDate,
                        dueDate: this.formatDate(item.dueDate),
                        isOverdue: moment(item.dueDate) < today && !isPaid,
                        isPaid: isPaid,
                        isPartPaid: isPartiallyPaid,
                        isSent: item.isPrinted,
                        invoiceAmount: this.bigNumberUtils.formatDecimal(item.invoicedAmount, 'c'),
                        openAmount: this.bigNumberUtils.formatDecimal(item.openAmount, 'c'),
                        realization: this.bigNumberUtils.formatDecimal(item.realizationPercentage, 'p')
                    };
                });
                return response;
            });

        }

        public formatDate(date: string): string {
            return this.dateUtils.formatDateFromInvariant(date, 'l');
        }

        public preview(id: string): void {
            let self = this;
            this.isBusy = true;
            this.invoiceService.preview(id).finally(() => self.isBusy = false);
        }

        public send(id: string): void {
            this.invoiceService.send(id);
        }

        public showBillableEntries(id: string): void {
            this.invoiceService.showBillableEntries(id);
        }

        public showAppliedAmounts(id: string): void {
            this.isBusy = true;
            this.invoiceService.showAppliedAmounts(id).finally(() => {
                this.isBusy = false;
                (<IBmPracticeWidgetService>this).refreshData(true);
            });
        }

    }

    angular.module('bm.practice.widgets.priorInvoices', ['csClientPriorInvoiceV1', 'bm.practice.widgets.InvoiceService', 'bmpBigNumberUtils', 'bmpDateUtils'])
        .service('bm-practice-widget-prior-invoices', BmPracticeWidgetPriorInvoices);
}
